import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';

import { Link } from 'react-router-dom';
import Clickable from '@prisjakt/ui-clickable';
import { H3Text, TitleSmallText, FontColor } from '@prisjakt/ui/text/variants';

import { ViewportContext } from '../viewport';

import { ExpertCategoryContent } from '../../types';

import * as S from './styles';

const ExpertsWidget = ({
  testsCount,
  toplistsCount,
  guidesCount,
  category,
  grid = false,
  toplists,
  tests,
}: ExpertCategoryContent & { grid: Boolean }) => {
  const { linkTo, renderMode, t } = useContext(AppContext);
  const { isMobile } = useContext(ViewportContext);

  if (!category || !(testsCount || toplistsCount || guidesCount)) return null;

  const content = [...(tests || []), ...(toplists || [])];

  const getInfoListItems = () => {
    return [
      toplistsCount ? `${toplistsCount} ${t('expert', 'toplist.lists')}` : null,
      testsCount ? `${testsCount} ${t('expert', 'test.tests')}` : null,
      guidesCount ? `${guidesCount} ${t('expert', 'guide.guides')}` : null,
    ].filter(item => item);
  };

  return (
    <S.Wrapper grid={grid}>
      <S.Header>
        <H3Text>{t('expert', 'widget.category-page-title')}</H3Text>
        <Link to={linkTo('experts')}>
          <TitleSmallText color={FontColor.PRIMARY}>
            {t('expert', 'widget.category-page-link')}
          </TitleSmallText>
        </Link>
      </S.Header>

      <S.Cards>
        <S.Card outlined={false}>
          <S.CardActionArea
            container={Clickable}
            containerProps={{
              to: linkTo(
                'expertCategory',
                { semantic_id: category.url },
                renderMode === 'native' ? { view: 'native' } : undefined
              ),
            }}
          >
            <S.CardBackgroundImage src={category.descriptionImage || ''}>
              <S.CardContent>
                <S.PreTitle>{t('expert', 'expert.role')}</S.PreTitle>
                <S.Title>{category.name}</S.Title>
                <S.Description>
                  <span>{t('expert', 'widget.category-page-description')}</span>
                  <S.InfoList list={getInfoListItems() as string[]} />
                </S.Description>
              </S.CardContent>
            </S.CardBackgroundImage>
          </S.CardActionArea>
        </S.Card>

        {isMobile && <S.ContentCards items={content} limit={4} hideExperts />}
      </S.Cards>
    </S.Wrapper>
  );
};

export default ExpertsWidget;
